export const getQuery = (queryFor) => {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let foo = params.get(queryFor);
  return foo;
}